import { create } from 'zustand';

export type ToastVariant = 'default' | 'success' | 'danger' | 'warning';

export interface ToastItem {
  id: string;
  message: string;
  variant: ToastVariant;
  duration: number;
}

interface ToastState {
  toasts: ToastItem[];
  show: (message: string, options?: { variant?: ToastVariant; duration?: number }) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

let counter = 0;
const nextId = () => `toast-${Date.now()}-${++counter}`;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  show: (message, options) => {
    const id = nextId();
    const item: ToastItem = {
      id,
      message,
      variant: options?.variant ?? 'default',
      duration: options?.duration ?? 4000,
    };
    set((s) => ({ toasts: [...s.toasts, item] }));
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  clear: () => set({ toasts: [] }),
}));
